import React from 'react';
import './style.scss';
import { IContentSection, ITableOfContentItem } from '../page-template';
import PageTemplate from '../page-template/component';
import HeaderImg from '../../../assets/images/travbusiness-template-pages/60a57291-8ac8-43dd-baa5-3c44f1bf8800.png'
import { useIntl } from 'react-intl';

const TravbusinesLoyaltyRewardsBenefitsForTravelersHotelAndCarPage: React.FC = () => {
 const { formatMessage } = useIntl();
const tocItems: ITableOfContentItem[] = [
    { id: 'how-it-works', title: formatMessage({ id: 'loyaltyRewards.howItWorks.title' }) },
    { id: 'redemption-options', title: formatMessage({ id: 'loyaltyRewards.redemptionOptions.title' }) },
    { id: 'no-extra-cost', title: formatMessage({ id: 'loyaltyRewards.noExtraCost.title' }) },
    { id: 'stack-your-benefits', title: formatMessage({ id: 'loyaltyRewards.stackYourBenefits.title' }) },
  ];
  
const sections: IContentSection[] = [
    {
      id: 'how-it-works',
      title: formatMessage({ id: 'loyaltyRewards.howItWorks.title' }),
      paragraphs: [
        formatMessage({ id: 'loyaltyRewards.howItWorks.para1' }),
        formatMessage({ id: 'loyaltyRewards.howItWorks.para2' }),
      ],
    },
    {
      id: 'redemption-options',
      title: formatMessage({ id: 'loyaltyRewards.redemptionOptions.title' }),
      paragraphs: [
        formatMessage({ id: 'loyaltyRewards.redemptionOptions.para1' }),
        formatMessage({ id: 'loyaltyRewards.redemptionOptions.para2' }),
      ],
    },
    {
      id: 'no-extra-cost',
      title: formatMessage({ id: 'loyaltyRewards.noExtraCost.title' }),
      paragraphs: [
        formatMessage({ id: 'loyaltyRewards.noExtraCost.para1' }),
        formatMessage({ id: 'loyaltyRewards.noExtraCost.para2' }),
      ],
    },
    {
      id: 'stack-your-benefits',
      title: formatMessage({ id: 'loyaltyRewards.stackYourBenefits.title' }),
      paragraphs: [
        formatMessage({ id: 'loyaltyRewards.stackYourBenefits.para1' }),
        formatMessage({ id: 'loyaltyRewards.stackYourBenefits.para2' }),
        formatMessage({ id: 'loyaltyRewards.stackYourBenefits.para3' }),
      ],
    },
  ];


  return (
    <div className="weeks-results-page">
      <PageTemplate
        headerImage={HeaderImg}
        headerTitle={formatMessage({ id: 'loyalty.rewards.benefits.headerTitle' })}
        headerSubtitle={formatMessage({ id: 'loyalty.rewards.benefits.headerSubtitle' })}
        tableOfContents={tocItems}
        contentSections={sections}
        positionHeaderImg='top'
      />
    </div>
  );
};


export default TravbusinesLoyaltyRewardsBenefitsForTravelersHotelAndCarPage;
